// Bottom card on AdminOverviewPage — the flat list of customer domains
// with add-domain CTA + empty state.
import React from 'react';
import { Globe, Plus } from 'lucide-react';
import { customerStatusPillClass } from './overviewHelpers';

const DomainRow = ({ d, onClick }) => (
  <div
    onClick={onClick}
    className="flex items-center px-6 py-4 hover:bg-white/5 cursor-pointer transition-colors"
    data-testid={`domain-row-${d.domain_id}`}
  >
    <div className="flex-1">
      <p className="text-white font-medium">{d.company_name || d.yabbit_domain}</p>
      <p className="text-white/30 text-xs">
        {d.yabbit_domain} · {d.industry?.replace(/_/g, ' ')}
      </p>
    </div>
    <div className="flex items-center gap-6 text-sm text-white/40">
      <span>{d.total_calls} calls</span>
      <span>{d.extensions_count} ext</span>
      <span className={`px-2 py-0.5 rounded-full text-xs font-medium ${customerStatusPillClass(d.status)}`}>
        {d.status}
      </span>
    </div>
  </div>
);

export const CustomerDomainsList = ({ domains, onAdd, onOpenDomain }) => (
  <div className="bg-white/5 border border-white/10 rounded-xl overflow-hidden">
    <div className="flex items-center justify-between px-6 py-4 border-b border-white/5">
      <h2 className="text-white font-semibold">Customer Domains</h2>
      <button
        onClick={onAdd}
        className="flex items-center gap-2 px-4 py-1.5 bg-teal-500 hover:bg-teal-400 text-white text-sm font-medium rounded-lg transition-colors"
        data-testid="add-domain-btn"
      >
        <Plus className="w-4 h-4" />
        Add Domain
      </button>
    </div>
    {domains.length === 0 ? (
      <div className="py-16 text-center">
        <Globe className="w-12 h-12 text-white/10 mx-auto mb-3" />
        <p className="text-white/30">No domains set up yet</p>
        <button
          onClick={onAdd}
          className="mt-4 text-teal-400 hover:text-teal-300 text-sm"
        >
          Add your first domain →
        </button>
      </div>
    ) : (
      <div className="divide-y divide-white/5">
        {domains.map(d => (
          <DomainRow
            key={d.domain_id}
            d={d}
            onClick={() => onOpenDomain(d.domain_id)}
          />
        ))}
      </div>
    )}
  </div>
);
